import { FormBuilderDisplayRenderer } from "../../../../../FormBuilder/components/FormBuilderDisplayRenderer/index.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Events/shared/EventInteractive/EventInfoFormBuilder/components/FormBuilderDisplay.tsx
function EventInfoFormBuilderDisplay({ event }) {
	if (!event.infoFormInput?.formId) return null;
	return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(FormBuilderDisplayRenderer, {
		formId: event.infoFormInput.formId,
		valuesByFieldId: event.infoFormInput?.fields || {}
	}, event.infoFormInput.formId) });
}
//#endregion
export { EventInfoFormBuilderDisplay };

//# sourceMappingURL=FormBuilderDisplay.js.map